import React from 'react';
import PropTypes from 'prop-types';
import PreviewDropzone from '../../../communities_manage/components/preview_dropzone';
import { startCase } from 'lodash';

const CompanyFormBody = ({ formData, handleFieldChange, optionsForLists, files, setFiles }) => {
  const { statusesList, categoryList, fundingStageList, marketsList } = optionsForLists;

  const renderInputField = (label, name, cssStyle, type = 'text') => {
    return (
      <div className={cssStyle}>
        <label className='t5 w3'>{label}</label>
        <input
          name={name}
          className='form-control'
          value={formData[name] || ''}
          onChange={handleFieldChange}
          type={type}
        />
      </div>
    );
  };

  const renderSelectField = (label, name, cssStyle, optionList) => {
    return (
      <div className={cssStyle}>
        <label className='t5 w3'>{label}</label>
        <select
          name={name}
          className='form-control'
          value={formData[name] || ''}
          onChange={handleFieldChange}
        >
          <option value='' className='text-capitalize'>Select {label}</option>
          {optionList.sort().map(value => {
            return (
              <option key={value} value={value}>{startCase(value)}</option>
            );
          })}
        </select>
      </div>
    );
  };

  return (
    <div className='container-fluid col-xs-8 no-float mb-50'>
      <h4 className='h4 w3 mb-15 mt-20'>Company Information</h4>
      <div className='row'>
        {renderInputField('Name', 'name', 'col-md-6 form-group')}
        {renderInputField('Display Name', 'display_name', 'col-md-6 form-group')}
      </div>
      <div className='row'>
        {renderInputField('Domain', 'domain', 'col-md-6 form-group')}
        {renderInputField('Location', 'location', 'col-md-6 form-group')}
      </div>
      <div className='row p-15'>
        <label className='t5 w3'>Description</label>
        <textarea
          name='description'
          className='form-control'
          value={formData.description || ''}
          onChange={handleFieldChange}
        />
      </div>
      <div className='row p-15'>
        <label className='t5 w3 block'>Company Profile Photo</label>
        <PreviewDropzone files={files} setFiles={setFiles} imgUrl={formData.headshot.url} />
      </div>
      <div className='row'>
        {renderSelectField('Status', 'status', 'col-md-6 form-group', statusesList)}
        {renderSelectField('Category', 'category', 'col-md-6 form-group', categoryList)}
      </div>
      <div className='row'>
        {renderInputField('Year Founded', 'year_founded', 'col-md-6 form-group', 'number')}
        {renderInputField('Employee Count', 'employee_count', 'col-md-6 form-group', 'number')}
      </div>
      <div className='row'>
        {renderInputField('Money Raised', 'money_raised', 'col-md-6 form-group', 'number')}
        {renderInputField('Annual Revenue', 'annual_revenue', 'col-md-6 form-group', 'number')}
      </div>
      <div className='row'>
        {renderSelectField('Funding Stage', 'funding_stage', 'col-md-6 form-group', fundingStageList)}
        {renderSelectField('Target Market', 'target_market', 'col-md-6 form-group', marketsList)}
      </div>
      <div className='row'>
        {renderInputField('Website Url', 'website_url', 'col-md-6 form-group')}
        {renderInputField('Linkedin', 'linkedin', 'col-md-6 form-group')}
      </div>
      <div className='row'>
        {renderInputField('Twitter', 'twitter', 'col-md-6 form-group')}
        {renderInputField('Facebook', 'facebook', 'col-md-6 form-group')}
      </div>
    </div>
  );
};

CompanyFormBody.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  optionsForLists: PropTypes.object.isRequired
};

export default CompanyFormBody;
